import { createSelector } from '@ngrx/store';
import { AppState } from '@state/app.state';

export const selectSystemState = (state: AppState) => state.system;

export const selectIsSidebar = createSelector(selectSystemState, state => state.isSidebar);

export const selectFacebookConfig = createSelector(selectSystemState, state => state.facebook);
